import { render, staticRenderFns } from "./MimeTvService.vue?vue&type=template&id=bdac16bc&scoped=true"
import script from "./MimeTvService.vue?vue&type=script&lang=js"
export * from "./MimeTvService.vue?vue&type=script&lang=js"
import style0 from "./MimeTvService.vue?vue&type=style&index=0&id=bdac16bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdac16bc",
  null
  
)

export default component.exports